import React, { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';

const WebLogoFind = ({ onImageSelect, storeName }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [error, setError] = useState(null);

    const searchLogo = async () => {
        if (!storeName || storeName.trim() === '') {
            setError("נא להזין שם חנות תחילה");
            return;
        }
        
        setIsLoading(true);
        setError(null);
        
        try {
            const functions = getFunctions();
            const searchLogoFunction = httpsCallable(functions, 'searchLogo');
            
            const result = await searchLogoFunction({
                query: storeName.trim()
            });
            
            const data = result.data;

            if (!data.items || data.items.length === 0) {
                setError("לא נמצאו תוצאות");
                setSearchResults([]);
                return;
            }

            setSearchResults(data.items.map(item => ({
                url: item.link,
                thumbnail: item.image.thumbnailLink,
                title: item.title
            })));
        } catch (error) {
            console.error("Error searching for logo:", error);
            setError(error.message || "שגיאה בחיפוש הלוגו");
        } finally {
            setIsLoading(false);
        }
    };

const handleImageSelect = async (imageUrl) => {
    // הפעל מצב טעינה
    setIsLoading(true);
    setError(null);

    try {
        const functions = getFunctions();
        const uploadImageFunction = httpsCallable(functions, 'uploadImageFromUrl');

        // קריאה לפונקציית השרת עם הכתובת החיצונית
        const result = await uploadImageFunction({ imageUrl: imageUrl });

        // קבלת הנתונים של הקובץ החדש שהועלה ל-Storage שלך
        const newFileData = result.data; // should be { downloadURL, filePath }

        // הפעלת הפונקציה של הקומפוננטה האב עם הנתונים החדשים
        onImageSelect(newFileData);

        setSearchResults([]); // נקה תוצאות אחרי בחירה מוצלחת
    } catch (error) {
        console.error("Error saving selected logo:", error);
        setError(error.message || "שגיאה בשמירת הלוגו");
    } finally {
        setIsLoading(false);
    }
};

    return (
        <div className="flex flex-col items-center gap-4">
            <div className="w-full flex justify-between gap-4">
                <button
                    onClick={searchLogo}
                    disabled={isLoading || !storeName || storeName.trim() === ''}
                    className={`px-4 py-2 rounded-lg font-semibold transition-colors ${
                        isLoading || !storeName || storeName.trim() === ''
                            ? 'bg-gray-600 cursor-not-allowed'
                            : 'bg-blue-600 hover:bg-blue-700'
                    } text-white`}
                >
                    {isLoading ? 'מחפש...' : 'חפש לוגו'}
                </button>
                <div className="flex-1 text-right">
                    <p className="text-sm text-gray-400 mb-1">שם החנות:</p>
                    <p className="text-lg">{storeName || 'לא הוגדר'}</p>
                </div>
            </div>

            {error && (
                <div className="w-full p-3 bg-red-900/50 border border-red-700 rounded-lg text-center">
                    {error}
                </div>
            )}

            {searchResults.length > 0 && (
                <div className="w-full">
                    <p className="text-sm text-gray-400 mb-2">לחץ על תמונה כדי לבחור אותה כלוגו:</p>
                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
                        {searchResults.map((result, index) => (
                            <div
                                key={index}
                                onClick={() => handleImageSelect(result.url)}
                                className="cursor-pointer hover:opacity-80 transition-opacity"
                            >
                                <img
                                    src={result.thumbnail}
                                    alt={result.title}
                                    className="w-full h-32 object-contain bg-gray-800 rounded-lg p-2"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default WebLogoFind; 